import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BibagueTraitement } from 'src/app/service/bibague.service';
import { PlanDeTraitementService } from 'src/app/service/planDeTraitement.service';
import { RccTraitement } from 'src/app/service/rcc.service';
import { TreatmentPlanMetaService } from 'src/app/service/treatment-plan-meta.service';

@Component({
  selector: 'app-pdt-details',
  templateUrl: './pdt-details.component.html',
  styleUrls: ['./pdt-details.component.scss'],
})
export class PdtDetailsComponent implements OnInit {

  constructor(
  ) { }
  @Output() close = new EventEmitter<void>();
@Input() selectedPdt: any = null;
  ngOnInit() {
    console.log("selectedPdt",this.selectedPdt);

  }

  closeModal() {
    this.close.emit();
}

getSelectionText(item: any, title: string): string {  
  if (!item || !item.dentSelections) return '—';

  // Trouver la section correspondant au titre (ex: "Taquets", "Stripping", etc.)
  const section = item.dentSelections.find((s: any) => s.title === title);
  if (!section) return '—';

  // Fusionner buttons et buttons2
  let allButtons: any[] = [];
  if (section.buttons) allButtons = allButtons.concat(section.buttons);
  if (section.buttons2) allButtons = allButtons.concat(section.buttons2);

  // Garder uniquement les boutons sélectionnés
  const selectedButtons = allButtons.filter((b: any) => b.selected);
  if (selectedButtons.length === 0) return '—';

  // Construire le texte pour chaque bouton sélectionné
  const result = selectedButtons.map((b: any) => {
    // Extraire les numéros de dents si disponibles
    if (b.variable && b.variable.length > 0) {
      const teethNumbers = b.variable.map((v: any) => v.numteeth).join(', ');
      return `${b.label} sur ${teethNumbers}`;
    } else {
      return b.label;
    }
  });

  // Retourner une chaîne lisible, séparée par des virgules
  return result.join(', ');
}

  rccOptions = [
    { key: 'verin_median', label: 'Vérin médian' },
    { key: 'plan_molaire', label: 'Plan molaire' },
    { key: 'pri', label: 'PRI' },
    { key: 'friels', label: 'Friels' },
    { key: 'cantilevers', label: 'Cantilevers' },
    { key: 'verin_recul', label: 'Verin Recul Postérieur' },
    { key: 'grille_anti_puce', label: 'Grille Anti pouce' },
    { key: 'crochet_tim', label: 'Crochet TIM' }
  ];

  getSelectedOptionLabels(selectedOptions): string[] {
    return selectedOptions.map(key => {
      const match = this.rccOptions.find(option => option.key === key);
      return match ? match.label : key;
    });
  }

   bibaguesOptions = [
  { key: 'quad_helix', label: 'Quad Helix' },
  { key: 'arc_lingual', label: 'Arc Lingual' },
  { key: 'disjonct', label: 'Disjonct' },
  { key: 'gouttieres_contention', label: 'Gouttières de contention' },
  { key: 'asi', label: 'A.S.I' },
  { key: 'modele_3d', label: 'Modèle 3D' },
  { key: 'fil_3_3_indirect', label: 'Fil 3-3 Indirect' },
  { key: 'gouttieres_chir', label: 'Gouttières Chir' },
];

  getOptionLabel(key: string): string {
  const found = this.bibaguesOptions.find(opt => opt.key === key);
  return found ? found.label : key;
}
  getOptionValue(key: string, item: any): string {
  switch (key) {
    case 'quad_helix': {
      const quadHelix = item.quadHelix || {};
      const subOptions: string[] = quadHelix.sousOptions || [];
      const pri = subOptions.includes('pri') && quadHelix.pri
        ? ` (Longueur: ${quadHelix.pri.longueur}, Hauteur: ${quadHelix.pri.hauteur})`
        : '';
      return subOptions.join(', ') + pri;
    }

    case 'disjonct': {
      return item.disjonct || '-';
    }

    case 'asi': {
      const asi = item.asi || {};
      return `Éruption: ${asi.eruption || '-'}, Setup: ${asi.setup || '-'}`;
    }


    case 'fil_3_3_indirect': {
      const fil = item.fil_3_3_indirect || {};
      const positions = fil.positions || [];
      return `Position: ${positions.join(', ')}, Matériau: ${fil.materiau || '-'}`;
    }

    case 'gouttieres_contention': {
      const g = item.gouttieres_contention || {};

      const maintiens = g.maintiens
        ? (g.maintiens.type === 'total'
            ? 'Maintiens: Total'
            : g.maintiens.type === 'de'
              ? `Maintiens: De ${g.maintiens.deStart} à ${g.maintiens.deEnd}`
              : '')
        : '';

      const boutons = g.boutons
        ? `Boutons: ${(g.boutons.choix || []).join(', ').toUpperCase()}${g.boutons.details ? ' (' + g.boutons.details + ')' : ''}`
        : '';

      const eruption = g.eruption ? `Éruption: ${g.eruption.join(', ')}` : '';
      const setup = g.setup ? `Setup: ${g.setup}` : '';
      const facettes = g.facettes ? `Facettes: ${g.facettes}` : '';
      const rigide = g.rigide ? 'Rigide: Oui' : '';

      return [maintiens, boutons, eruption, setup, facettes, rigide]
        .filter(val => val)
        .join(' \n ');
    }

    case 'arc_lingual': {
      return item.arc_lingual ? 'Oui' : '-';
    }

    case 'gouttieres_chir': {
      const pos = (item.gouttieres_chir && item.gouttieres_chir.positions) ? item.gouttieres_chir.positions : [];
      return pos.length
        ? `Gouttières Chirurgicales: ${pos.map(p => p === 'haut' ? 'Haut' : p === 'bas' ? 'Bas' : p).join(', ')}`
        : '-';
    }


    case 'modele_3d': {
      return item.modele_3d ? 'Oui' : 'Non';
    }

    default:
      return '-';
  }
}

  getFilteredOptions(options: string[], item: any): string[] {
  return options.filter(opt => {
    const value = this.getOptionValue(opt, item);
    return value && value.trim() !== '-' && value.trim() !== '';
  });
}

}
